
export const workList = [
    {
        company: 'Openfabric',
        position: 'Frontend Developer',
        startDate: 'July 2023',
        endDate: '- Present',
        responsibilities: 'Improving the efficiency and familiarity of the user experience by incorporating design systems and creating reusable components. Providing technical insights and solutions to align design concepts with feasible implementations.',
        skills: [
            'Angular', 'SASS', 'TypeScript', 'Angular Material', 'JSON:API'
        ]
    },
    {
        company: 'Cars Verify',
        position: 'Full Stack Developer/CTO',
        startDate: 'May 2023',
        endDate: '- Present',
        responsibilities: 'I assume a pivotal role in design oversight, frontend and backend development as I spearhead the building of the mobile application',
        skills: [
            'React', 'React native', '.Net', 'Digital Ocean', 'GitHub Actions', 'Docker', 'Postgres', 'Kubernetes'
        ]
    },
    {
        company: 'Eminent Technology',
        position: 'Full Stack Developer',
        startDate: 'July 2021',
        endDate: '- Mar 2023',
        responsibilities: 'Delivered high-quality, robust production code, and counseling for a diverse array of projects for clients including Xom Mobil, American Family, Maverick Natural Resource, Usource, and more.',
        skills: [
            'Angular', 'AngularJS', 'Ionic', '.Net', 'AWS', 'Azure', 'MSSQL'
        ]
    },
    {
        company: 'ECO Global Solution',
        position: 'Full Stack Developer',
        startDate: 'Sept 2019',
        endDate: '- Jan 2021',
        responsibilities: 'Worked closely with the product owner to understand their vision for the web application. Identified and prioritized business requirements, and ensured that they were met promptly and efficiently. Successfully raised £2,500 in funding for the initial stage of the application.',
        skills: [
            'Angular', '.Net', 'Azure', 'Postgres', 'Digital Ocean', 'GitHub Actions', 'Docker'
        ]
    },
    {
        company: 'Marg Education Limited',
        position: 'Full Stack Developer',
        startDate: 'Jan 2016',
        endDate: '- July 2017',
        responsibilities: 'Engineered a powerful web-based management tool, trained and supported staff in the seamless transition from file cabinets to our new web-based management application.',
        skills: [
            'Angular', '.Net', 'Postgres', 'Digital Ocean', 'Docker', 'Docker Swarm'
        ]
    },
];

